import { em } from '@mantine/core';

export const isDesktopParam = '(min-width: 1400px)';
export const isMobileParam = `(max-width: ${em(768)})`;
